// Release Switch Toggles: should not be used directly
// @see getReleaseSwitchToggleCookieName util
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_SWITCH_TOGGLE_AT = 'release-switch-at'

// Release Toggles
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_CART_CTA_DELAYED = 'cart-cta-delayed'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_NOW = 'now'
export const RELEASE_TOGGLE_MP_CROSS_SELL = 'mp-cross-sell'
export const RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED = 'enabled'
export const RELEASE_TOGGLE_VARIANT_ATTRIBUTES = 'variant-attributes'
export const RELEASE_TOGGLE_HOME_ONE = 'home-one'
export const REBRANDING_IT_TOGGLE = 'rebranding-it'
export const REBRANDING_COM_TOGGLE = 'rebranding-com'
export const HOME_ONE_FRONTEND = 'frontend'
export const ERX_ADYEN_TOGGLE = 'erx-adyen'
export const ERX_ADYEN_MP_TOGGLE = 'erx-adyen-mp'
export const ERX_NOW_TOGGLE = 'erx-now'
export const APPLE_PAY_TOGGLE = 'wstra-2462'
export const CPH_MAX_DOSAGE_TOGGLE = 'wstra-5851'

// Experiments
export const SWITCH_PRODUCT_WIDGET = 'cro-1719'
export const XSELL_NEW_LAYOUT = 'xsell-new-layout'
export const PDP_CSW_NEW_ALGO = 'pdp-csw-new-algo'
export const SERVICE_LINKS_CSW = 'service-links-csw'
export const ODS_CLIENT_FLOW = 'ods-client-flow'
export const ODS_PDP_MODAL = 'wsssh-188'
export const ODS_PDP_TOOLTIP = 'wsssh-859'
export const NEW_HEADER = 'header'
export const PDP_APP_BANNER = 'pdp-app-banner'
export const PDP_APP_BANNER_AT = 'cro-931'
export const PDP_APP_BANNER_IT = 'cro-1663'
export const PDP_APP_BANNER_CH = 'cro-2137'
export const PDP_VARIANTS_POSITION = 'cro-459'
export const CSW_PRODUCT_TITLE = 'cro-780'
export const SERP_NOW_PUSH = 'cro-121'
export const SERP_LOAD_MORE = 'cro-179'
export const COLLECTIVE_ORDER_CHECKBOX = 'wstra-2044'
export const VARIANT_ATTRIBUTES = 'variant-attributes'
export const CART_VOUCHER_DISPLAY = 'cro-929'
export const NEW_CSW = 'cro-513'
export const FREE_SHIPPING_INDICATOR = 'cro-757'
export const REPLACE_CUSTOMER_RATINGS_COM = 'cro-985'
export const EXTENDED_SEARCHBOX_RESULTS = 'cro-1244'
export const NOW_CART_FUNCTIONALITY = 'wstra-3548'
export const HOME_SWAP_CSW_AND_SERVICES = 'cro-748'
export const NOW_PDP_SERP_GB_FUNCTIONALITY = 'wstra-4055'
export const SERP_REFINED_QUERIES = 'cro-1195'
export const ORDER_CANCELLATION = 'wsssh-1429'
// INFO: there are two order cancellation toggles:
// the old MVP (above) and the new functionality (below) that will replace the MVP
// We have to keep it this way so we don't use A/B
// until we go live with the new functionality
export const ORDER_CANCELLATION_NEW_FUNCTIONALITY = 'wsssh-1429-new'
export const CART_CSW_CHANGE_PLACE = 'cro-854'
export const TOP_DEALS_LABEL = 'cro-1073'
export const OOS_REPLACEMENT_PRODUCT_OVERLAY = 'cro-940'
export const NEWSLETTER_MODAL_FR = 'cro-1814'
export const USP_BANNER_IT = 'cro-1888'
export const CSW_ON_SERP = 'cro-1848'
export const CAT_MORE_PRODUCTS_ON_FIRST_CSW = 'cro-1561'
export const XSELL_SHIPPING_PRICE = 'cro-1587'
export const CART_OWN_BRANDS_IN_CSW = 'cro-1865'
export const PDP_CSW_POSITION_CHANGE = 'cro-1969'
export const CONFIRMATION_PAGE_BANNER = 'cro-2074'

export const CONFIRMATION_PAGE_CSW = 'cro-1891'
export const CTA_BUTTON_ON_ALL_CSW = 'cro-2052'
export const SERP_PRE_QUERY_SUGGESTIONS = 'cro-2042'
export const CSW_ON_HOMEPAGE = 'cro-1798'
export const CAT_REMOVE_CTA_AND_VARIANTS = 'cro-1754'
export const SERP_MOBILE_LAYOUT_IT = 'cro-2020'
export const SERP_REMOVE_CTA_AND_VARIANTS = 'cro-1871'
export const CART_WID_REPLACE_FR_CH = 'cro-1069'
export const SEARCH_BUTTON_CHANGE = 'cro-901'

export const NOW_PDP_GB_FUNCTIONALITY = 'wstra-5030'
export const NOW_HOMEPAGE_GB_FUNCTIONALITY = 'wstra-5032'
export const NOW_SERP_GB_FUNCTIONALITY = 'wstra-5031'
export const NOW_CATEGORY_GB_FUNCTIONALITY = 'wstra-5033'
export const PDP_CSW_TITLE_CHANGE = 'cro-2160'

// ad-server experiments' name
export const AD_SERVER = 'ad-server'
export const AD_SERVER_SEARCH_PRODUCT = 'ad-se'
export const AD_SERVER_CROSSSELL_PRODUCT = 'ad-xs'
export const AD_SERVER_BANNER = 'ad-ba'

export const HIDE_VIDEO_CONSULTATION = 'wsssh-1561'
export const RETURN_LABEL = 'wsssh-1793'
export const SHOW_APPLICABLE_CREDIT_BALANCE_FOR_CART_AND_CHECKOUT = 'wsssh-2003'
export const RETAIL_MEDIA_CROSS_SELL_SERVICE = 'rmadt-954'

export const PASSWORD_ENFORCEMENT_REGISTER = 'wscnl-2098-register'
export const PASSWORD_ENFORCEMENT_RESET_PASSWORD = 'wscnl-2098-reset-password'
export const PASSWORD_ENFORCEMENT_CHANGE_PASSWORD = 'wscnl-2098-change-password'
